
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '@core/services';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);
  let isValidUser :boolean = authenticationService.isAuthenticated();
  if (isValidUser) {
    return true;
  }
  router.navigate(['/login']);
  return false;
};
